import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export const HousekeepingHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 1.25rem;
`

export const HousekeepingSubline = styled.p`
  font-size: ${tokens.font.body};
  color: ${tokens.text.muted};
`

export const SubTabs = styled.div`
  margin-bottom: 1.5rem;
`

export const StatBand = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: ${tokens.space.sm};
  margin-bottom: 1.5rem;

  @media (max-width: 1180px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 680px) {
    grid-template-columns: 1fr;
  }
`

export const SectionTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
  justify-content: space-between;
`

export const SectionTitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const SectionCount = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.25rem;
  height: 1.25rem;
  padding: 0 0.375rem;
  border-radius: ${tokens.radius.chip};
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  font-size: ${tokens.font.micro};
  font-weight: 600;
  color: ${tokens.text.secondary};
  font-variant-numeric: tabular-nums;
`

export const Caption = styled.p`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
  margin-bottom: 0.75rem;
`

export const BedRow = styled.div`
  display: grid;
  grid-template-columns: minmax(6rem, 0.9fr) minmax(12rem, 2fr) minmax(6rem, 0.8fr) auto;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 0;
  border-bottom: 1px solid ${tokens.border.hairline};

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    gap: 0.5rem;
    padding: 0.875rem 0;
  }
`

export const BedIdentity = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
  min-width: 0;
`

export const BedLabel = styled.span`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${tokens.text.primary};
`

export const BedLocation = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};

  svg {
    width: 0.85rem;
    height: 0.85rem;
    flex: none;
  }
`

export const RowActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  justify-content: flex-end;
  flex: none;

  @media (max-width: 900px) {
    justify-content: flex-start;
  }
`

export const EmptyState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.75rem 0;
  font-size: ${tokens.font.body};
  color: ${tokens.text.muted};
`

export const LoaderWrap = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 0;
`

export const CampBreakdown = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
`

export const CampChip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.3rem 0.6rem;
  border-radius: ${tokens.radius.chip};
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  font-size: ${tokens.font.micro};
  color: ${tokens.text.secondary};
`

export const CampChipCount = styled.span`
  font-weight: 600;
  color: ${tokens.text.primary};
  font-variant-numeric: tabular-nums;
`

export const BlockRoomBar = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  margin-bottom: 1.5rem;
  padding: 0.75rem 1rem;
  border-radius: ${tokens.radius.card};
  background: ${tokens.surface.glass};
  backdrop-filter: blur(${tokens.blur});
  border: 1px solid ${tokens.border.hairline};
`

export const BlockRoomHint = styled.span`
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
  flex: 1;
  min-width: 12rem;
`

export const RoomSelect = styled.select`
  height: 2.25rem;
  min-width: 14rem;
  padding: 0 0.75rem;
  border-radius: ${tokens.radius.control};
  background: ${tokens.surface.inset};
  border: 1px solid ${tokens.border.hairline};
  color: ${tokens.text.primary};
  font-size: ${tokens.font.body};
  cursor: pointer;
  outline: none;

  &:focus {
    border-color: ${tokens.accent.base};
  }

  option {
    background: ${tokens.surface.base};
    color: ${tokens.text.primary};
  }
`
